import VehicleBrand from './VehicleBrand'

export default VehicleBrand
